import Keycloak from 'keycloak-js'

/** The part of keycloak-js the app uses; tests pass a fake. */
export interface KeycloakLike {
    token?: string
    updateToken(minValidity: number): Promise<boolean>
    login(options?: { redirectUri?: string }): Promise<void>
    logout(options?: { redirectUri?: string; logoutMethod?: 'GET' | 'POST' }): Promise<void>
}

let instance: KeycloakLike | null = null

/** Starts the login before the app mounts: every screen needs a logged-in user (spec D73). */
export async function startKeycloak(configUrl = '/keycloak.json'): Promise<KeycloakLike> {
    const keycloak = new Keycloak(configUrl)
    await keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256', checkLoginIframe: false })
    return keycloak
}

export function provideKeycloak(keycloak: KeycloakLike): void {
    instance = keycloak
}

export function useKeycloak(): KeycloakLike {
    if (instance === null) {
        throw new Error('Keycloak has not been started')
    }
    return instance
}
